import { useEffect, useRef } from "react"
import "./MenuTabs.css"

export function MealPeriodTabs({ mealPeriods, selectedName, onSelect }) {
  const stripRef = useRef(null)
  useCenterSelected(stripRef, selectedName)

  return (
    <div className="tab-strip scroll-x" ref={stripRef}>
      <div className="tab-strip__track tab-strip__track--periods">
        {mealPeriods.map((period) => {
          const isSelected = period.name === selectedName
          return (
            <button
              key={period.id || period.name}
              type="button"
              data-tab-id={period.name}
              className={`meal-tab t-sb14${isSelected ? " meal-tab--selected" : ""}`}
              aria-pressed={isSelected}
              onClick={() => onSelect(period)}
            >
              {period.name}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export function CategoryTabs({ categories, selectedName, onSelect }) {
  const stripRef = useRef(null)
  useCenterSelected(stripRef, selectedName)

  if (!categories.length) return null

  return (
    <div className="category-strip">
      <div className="tab-strip scroll-x" ref={stripRef}>
        <div className="tab-strip__track">
          {categories.map((category) => {
            const isSelected = category.name === selectedName
            return (
              <button
                key={category.id || category.name}
                type="button"
                data-tab-id={category.name}
                className={`category-tab t-il12${isSelected ? " category-tab--selected" : ""}`}
                aria-pressed={isSelected}
                onClick={() => onSelect(category)}
              >
                {category.name}
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}

// Keeps the active tab in view when it changes from outside a tap.
function useCenterSelected(stripRef, selectedName) {
  useEffect(() => {
    if (!selectedName) return
    const strip = stripRef.current
    const tab = strip?.querySelector(`[data-tab-id="${CSS.escape(selectedName)}"]`)
    tab?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })
  }, [selectedName, stripRef])
}
